import { LocationCityRounded } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

export default function RegionIcon(props: SvgIconProps) {
    return <LocationCityRounded {...props} />;
}
